
  /* ORIGINAL: track scroll + arrow nav (unchanged except the scroll-restore guard) */
  (function () {
    const track = document.querySelector('.blog-circle-track');
    if (!track) return;
    const prev = document.querySelector('.circle-nav.prev');
    const next = document.querySelector('.circle-nav.next');
    const STORAGE_KEY = 'blogTabsScroll';

    function getScrollAmount() {
      return track.clientWidth;
    }
    function updateNavState() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (!prev || !next) return;
      if (maxScroll <= 0) {
        track.classList.remove('is-scrollable');
        prev.setAttribute('disabled', '');
        next.setAttribute('disabled', '');
        return;
      }
      track.classList.add('is-scrollable');
      track.scrollLeft <= 5 ? prev.setAttribute('disabled', '') : prev.removeAttribute('disabled');
      track.scrollLeft >= maxScroll - 5 ? next.setAttribute('disabled', '') : next.removeAttribute('disabled');
    }

    // Restore the saved horizontal tab-scroll — BUT NOT when the base/"All Blogs"
    // tab is the active one. A scroll saved while a far-right topic tab was
    // centered would push the (left-most) All Blogs tab out of view, leaving it
    // highlighted but off-screen after landing. Keeping scroll at 0 in that case
    // shows All Blogs exactly where the user expects it.
    var _tabsC = document.querySelector('.blog-circle-tabs');
    var _baseUrl = (_tabsC && _tabsC.dataset.blogUrl) || '/blogs/blog';
    function _np(u) { try { return new URL(u, location.origin).pathname; } catch (e) { return u; } }
    var _activeItem = track.querySelector('.blog-circle-item.is-active');
    var _activeIsBase = _activeItem && _np(_activeItem.getAttribute('href')) === _np(_baseUrl);
    const savedScroll = sessionStorage.getItem(STORAGE_KEY);
    if (savedScroll && !_activeIsBase) track.scrollLeft = parseInt(savedScroll, 10);

    track.addEventListener('scroll', () => {
      sessionStorage.setItem(STORAGE_KEY, track.scrollLeft);
      updateNavState();
    });
    prev?.addEventListener('click', () => {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });
    next?.addEventListener('click', () => {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });
    window.addEventListener('resize', updateNavState);
    updateNavState();
  })();
